import { Mods, mods } from '@approvalmax/theme';
import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    width: 100%;
    padding-right: 20px;
    padding-bottom: 20px;
`;

export const Header = styled.div`
    font-size: 16px;
    margin-top: 30px;
`;

export const BeneficiaryData = styled.div<Mods<'progress'>>`
    ${mods.progress.true`
        opacity: 0.5;
    `};
`;

export const SectionHeader = styled.div`
    ${font(14, '#000', 'semibold')};
    margin-top: 30px;
`;

export const SectionContent = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const Item = styled.div`
    width: 20%;
    margin-top: 20px;
`;

export const ItemHeader = styled.div`
    ${font(11, '#384650', 'semibold')};
`;

export const ItemText = styled.div`
    font-size: 13px;
    margin-top: 4px;
`;

export const Devider = styled.div`
    background-color: #cacccd;
    width: 100%;
    height: 1px;
    margin-top: 18px;
`;
